import {client} from './services/client'

export  const newsletters = {
    namespaced:true,
    state:{
        newsletters:[],
        newsletter:[],
    },
    mutations: {
        SET_NEWSLETTERS (state,newsletters){
            state.newsletters = newsletters
        },
        SET_NEWSLETTER (state,newsletter){
            state.newsletter = newsletter
        },

    },
    actions: {
        get({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/newsletters/get',
                })
                    .then((response)=>{
                        let newsletters = response.data.newsletters;
                        commit('SET_NEWSLETTERS',newsletters)
                        resolve(response.data);


                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getOne({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/newsletters/get/one/'+id,
                })
                    .then((response)=>{
                        let newsletter= response.data.newsletter;
                        commit('SET_NEWSLETTER',newsletter)
                        resolve(response.data);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

        filter({commit},cat){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/newsletters/filter/by/categorie/'+cat,
                }).then((response)=>{
                    commit('SET_NEWSLETTERS',response.data.newsletters)
                    resolve(response.data);

                }).catch((error)=>{
                    reject(error);
                })
            })

        },
        set({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/newsletters/save',
                    data:data,
                })
                    .then((response)=>{
                        let newsletters = response.data.newsletters;
                        commit('SET_NEWSLETTERS',newsletters)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        delete({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/newsletters/delete/'+id,
                })
                    .then((response)=>{
                        let newsletters = response.data.newsletters;
                        commit('SET_NEWSLETTERS',newsletters);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
        corbeille({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/newsletters/corbeille/'+id,
                })
                    .then((response)=>{
                        let newsletters = response.data.newsletters;
                        commit('SET_NEWSLETTERS',newsletters);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
        restitue({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/newsletters/restitue/'+id,
                })
                    .then((response)=>{
                        let newsletters = response.data.newsletters;
                        commit('SET_NEWSLETTERS',newsletters);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        get: state  => {
            return state.newsletters
        },
    }
};
